import { ChipStatus, LabelItem } from 'src/app/components';
import TabDrawTableContent from './TabDrawTableContent';
import { DrawingModel } from 'src/app/modules/campaign/models/LuckyDraw.model';
import Gallery from 'src/app/components/Display/Gallery/Gallery.page';

export interface TabDrawInfoContentProps {
  data?: DrawingModel
}

export default function TabDrawInfoContent({ data }: TabDrawInfoContentProps) {
  const renderRemarks = (remarks: string[] = []) => {
    return remarks.map((remark: string, index: number) => {
      return (
        <li key={`remark-${index}`} className='text-[0.75rem] list-disc ml-4'>
          {
            `${remark}`
          }
        </li>)
    })
  }

  return (
    <>
      <div className='py-6 font-bold text-sm'>Customer Information</div>
      <LabelItem className='gap-1' label='PG Number' value={data?.member?.member_code} />
      <LabelItem className='gap-1' label='Customer Name' value={data?.member?.fullname} />
      <LabelItem
        className='gap-1'
        label='Customer Remarks'
        value={data?.customer_remarks || data?.member?.customer_remarks}
        renderValue={(_) => <ChipStatus state={_} />}
      />
      <LabelItem className='gap-1' label='Gender' value={data?.member?.gender} />
      <LabelItem className='gap-1' label='Phone Number' value={data?.member?.phone_number} />
      <LabelItem className='gap-1' label='Email' value={data?.member?.email} />
      <LabelItem className='gap-1' label='ID Type' value={data?.member?.identity_type} />
      <LabelItem className='gap-1' label='ID Number' value={data?.member?.identity_number} />
      <LabelItem className='gap-1' label='ID Photo'>
        <Gallery
          bigThumbnail={true}
          items={[{
            id: data?.member?.id!,
            image: data?.member?.identity_image!,
            thumbnail: data?.member?.identity_image!,
            title: `${data?.member?.id}_image`,
          }]} />
      </LabelItem>
      <LabelItem className='gap-1' label='Customer Status'>
        <div>
          <ChipStatus state={data?.member?.status} />
        </div>
      </LabelItem>
      <div className='py-6 font-bold text-sm'>Coupon Information</div>
      <LabelItem className='gap-1' label='Coupon ID' value={data?.coupon_code} />
      <LabelItem className='gap-1' label='Receipt ID' value={data?.receipt_code} />
      {data?.is_printable && (
        <LabelItem className='gap-1' label='Print Location' value={data?.print_directory?.directory_name} />
      )}
      <LabelItem className='gap-1' label='Draw Location' value={data?.draw_directory?.directory_name} />
      <LabelItem className='gap-1' label='Prize' value={data?.prize?.name} />
      {data?.is_printable && (
        <LabelItem className='gap-1' label='Print ID' value={data?.coupon_printed_code} />
      )}
      <LabelItem className='gap-1' label='Coupon Status'>
        <div>
          <ChipStatus state={data?.status} />
        </div>
      </LabelItem>
      <LabelItem className='gap-1' label='Remarks'>
        {
          <ul>
            {renderRemarks(data?.remarks)}
          </ul>
        }
      </LabelItem>
      {data?.is_printable && (
        <div className='pt-6'>
          <TabDrawTableContent data={data} />
        </div>
      )}
    </>
  )
}